module.exports = __webpack_public_path__ + "img/icon-menu-time.14ad26c4.svg";